import { createActionGroup, createFeature, createReducer, createSelector, emptyProps, on, props } from '@ngrx/store';
import { produce } from 'immer';

export type ConsentType = 'essential' | 'all' | null;

export interface NgrxConsentState {
  serialized: ConsentType;
}

export const consentActions = createActionGroup({
  source: 'consent',
  events: {
    'init': emptyProps(),
    'show banner': emptyProps(),
    'hide banner': emptyProps(),
    'set consent': props<{ consent: ConsentType; }>(),
  }
});

export const consentFeature = createFeature({
  name: 'consent',
  reducer: createReducer<NgrxConsentState>(
    {
      serialized: null,
    },
    on(consentActions.init, produce((state) => {
      const stored = consentStorage.get();
      if (stored) {
        state.serialized = stored;
      }
    })),
    on(consentActions.setConsent, produce((state, { consent }) => {
      state.serialized = consent;
      consentStorage.set(consent);
    })),
  ),
  extraSelectors: base => {
    return {
      userHasInteracted: createSelector(base.selectSerialized, s => s !== null),
      analyticsEnabled: createSelector(base.selectSerialized, s => s === 'all')
    };
  }
});

const consentStorage = {
  key: 'mapa-cookie-consent',

  get(): ConsentType {
    return localStorage.getItem(this.key) as ConsentType;
  },

  set(consent: ConsentType): void {
    if (consent) {
      localStorage.setItem(this.key, consent);
    } else {
      localStorage.removeItem(this.key);
    }
  },

  clear(): void {
    localStorage.removeItem(this.key);
  },
} as const;